import Component from '../core/Component';
import $ from 'jquery';

export default class MenuCategories extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        this.$element.on('click', ::this.toggle);

    }

    toggle(event) {
        event.preventDefault();
        $(this.$element.attr('href')).toggleClass('show');
    }
}


// WEBPACK FOOTER //
// ./components/Unfold.js